import { LazyAction, LazyModule } from 'owa-bundling';
import { BaseLinkPreviewObject } from 'owa-link-preview/lib/utils/BaseLinkPreviewObject';
import { lazyCreateLinkPreview, lazyRehydrateLinkPreview } from 'owa-link-preview';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "LinkPreview" */ './lazyIndex')
);

export const lazyAddInteractiveElementsForReadingPane = new LazyAction(
    lazyModule,
    m => m.addInteractiveElementsForReadingPane
);

export { BaseLinkPreviewObject, lazyCreateLinkPreview, lazyRehydrateLinkPreview };
